<div fxLayout="column">
    <!-- IE requires all fxLayout="column" elements to have the child contents wrapped in a plain div tag -->
    <div *ngIf="isBrowserIE; else paymentAutomaticFormFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
        <ng-container *ngTemplateOutlet="paymentAutomaticFormFlexColumnTemplate"></ng-container>
    </div>
</div>

<ng-template #paymentAutomaticFormFlexColumnTemplate>
    <div fxLayout="column">
        <div class="display-text normal-paragraph-spacing" style="text-align: center" *ngIf="showSpinner">
            <mat-spinner color="accent" diameter="32"></mat-spinner>
        </div>
        <div fxLayout="column" *ngIf="!showSpinner">
            <div *ngIf="isBrowserIE; else paymentAutomaticFormMainFlexColumnTemplate"
                [ngClass]="{ 'ie-display': isBrowserIE }">
                <ng-container *ngTemplateOutlet="paymentAutomaticFormMainFlexColumnTemplate"></ng-container>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #paymentAutomaticFormMainFlexColumnTemplate>
    <!-- <div fxFlex="100%" class="display-text normal-paragraph-spacing">
    <span i18n="@@payment-automatic-form.main.top-statement.1">payment-automatic-form.main.top-statement.1</span> <br />&nbsp;<br /><b
      ><span style="text-decoration: underline;" i18n="@@payment-automatic-form.main.top-statement.2"
        >payment-automatic-form.main.top-statement.2</span
      ></b
    >
  </div> -->
    <div fxFlex="100%" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap.lt-md="10px"
        *ngIf="noteAutoPayInformationFound">
        <div *ngIf="isBrowserIE && media.isActive('lt-md'); else paymentAutomaticFormFormFlexColumnTemplate">
            <ng-container *ngTemplateOutlet="paymentAutomaticFormFormFlexColumnTemplate"></ng-container>
        </div>
    </div>
    <!--10/07/20221 RA - Added new Legal Text -->
    <div fxLayout="column" *ngIf="!showSpinner">
        <div *ngIf="isBrowserIE; else paymentAutomaticFormMainFlexColumnTemplate2"
            [ngClass]="{ 'ie-display': isBrowserIE }">
            <ng-container *ngTemplateOutlet="paymentAutomaticFormMainFlexColumnTemplate2"></ng-container>
        </div>
    </div>
    <div fxFlex="100%" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap.lt-md="10px" style="margin-top: 16px"
        *ngIf="noteAutoPayInformationFound">
        <div *ngIf="isBrowserIE && media.isActive('lt-md'); else paymentAutomaticFormOptionsFlexColumnTemplate">
            <ng-container *ngTemplateOutlet="paymentAutomaticFormOptionsFlexColumnTemplate"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #paymentAutomaticFormFormFlexColumnTemplate>
    <div fxFlex="100%">
        <form [formGroup]="paymentAutomaticForm">
            <div fxLayout="column">
                <div fxLayout="row" fxLayoutAlign="center center"
                    class="display-text normal-paragraph-spacing highlighted-display-text">
                    <b><span i18n="@@payment-automatic-form.form.title">payment-automatic-form.form.title</span></b>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
                    <mat-form-field fxFlex="40%" fxFlex.lt-md="100%">
                        <input matInput i18n-placeholder="@@payment-automatic-form.form.participant-id.label"
                            placeholder="payment-automatic-form.form.participant-id.label" type="text"
                            [value]="participantId" autocomplete="off" readonly />
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
                    <mat-form-field fxFlex="40%" fxFlex.lt-md="100%">
                        <input matInput i18n-placeholder="@@payment-automatic-form.form.note-id.label"
                            placeholder="payment-automatic-form.form.note-id.label" type="text" [value]="noteId"
                            autocomplete="off" readonly />
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
                    <mat-form-field fxFlex="40%" fxFlex.lt-md="100%">
                        <input matInput i18n-placeholder="@@payment-automatic-form.form.name.label"
                            placeholder="payment-automatic-form.form.name.label" type="text"
                            [formControl]="nameFormControl" autocomplete="off"
                            [maxlength]="fieldValidations.payment.nameMaxLength" required />
                        <mat-error class="form-error" *ngIf="nameFormControl.hasError('required')"
                            i18n="@@payment-automatic-form.form.error.required">payment-automatic-form.form.error.required</mat-error>
                    </mat-form-field>
                </div>

                <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
                    <mat-form-field fxFlex="40%" fxFlex.lt-md="100%">
                        <input matInput i18n-placeholder="@@payment-automatic-form.form.address1.label"
                            placeholder="payment-automatic-form.form.address1.label" type="text"
                            [formControl]="addressLine1FormControl" autocomplete="off"
                            [maxlength]="fieldValidations.payment.addressLine1MaxLength" required />
                        <mat-error class="form-error" *ngIf="addressLine1FormControl.hasError('required')"
                            i18n="@@payment-automatic-form.form.error.required">payment-automatic-form.form.error.required</mat-error>
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
                    <mat-form-field fxFlex="40%" fxFlex.lt-md="100%">
                        <input matInput i18n-placeholder="@@payment-automatic-form.form.address2.label"
                            placeholder="payment-automatic-form.form.address2.label" type="text"
                            [formControl]="addressLine2FormControl" autocomplete="off"
                            [maxlength]="fieldValidations.payment.addressLine2MaxLength" />
                        <mat-error class="form-error" *ngIf="addressLine2FormControl.hasError('required')"
                            i18n="@@payment-automatic-form.form.error.required">payment-automatic-form.form.error.required</mat-error>
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
                    <mat-form-field fxFlex="30%" fxFlex.lt-md="100%">
                        <input matInput i18n-placeholder="@@payment-automatic-form.form.city.label"
                            placeholder="payment-automatic-form.form.city.label" type="text"
                            [formControl]="cityFormControl" autocomplete="off"
                            [maxlength]="fieldValidations.payment.cityMaxLength" required />
                        <mat-error class="form-error" *ngIf="cityFormControl.hasError('required')"
                            i18n="@@payment-automatic-form.form.error.required">payment-automatic-form.form.error.required</mat-error>
                    </mat-form-field>
                    <span fxFlex="10%" fxHide.lt-md></span>
                </div>
                <!-- 02/23/2020 RA Added Country Dropdown box -->
                <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
                    <mat-form-field fxFlex="20%" fxFlex.lt-md="100%">
                        <mat-select *ngIf="allowPaymentInfoEdit"
                            i18n-placeholder="@@payment-automatic-form.form.country.label"
                            placeholder="payment-automatic-form.form.country.label" [formControl]="countryFormControl"
                            autocomplete="off" required>
                            <mat-option *ngFor="let country of countryList" value="{{ country.countryCode }}">{{
                                country.countryDescription }}</mat-option>
                        </mat-select>
                        <mat-select *ngIf="!allowPaymentInfoEdit"
                            i18n-placeholder="@@payment-automatic-form.form.country.label"
                            placeholder="payment-automatic-form.form.country.label" [formControl]="countryFormControl"
                            autocomplete="off" required>
                            <mat-option *ngFor="let country of countryList" value="{{ country.countryCode }}">{{
                                country.countryDescription }}</mat-option>
                        </mat-select>
                        <mat-error class="form-error" *ngIf="countryFormControl.hasError('required')"
                            i18n="@@payment-automatic-form.form.error.required">payment-automatic-form.form.error.required</mat-error>
                    </mat-form-field>
                    <span fxFlex="20%" fxHide.lt-md></span>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
                    <mat-form-field fxFlex="20%" fxFlex.lt-md="100%">
                        <mat-select i18n-placeholder="@@payment-automatic-form.form.state.label"
                            placeholder="payment-automatic-form.form.state.label" [formControl]="stateFormControl"
                            autocomplete="off" required>
                            <mat-option *ngFor="let state of stateList" value="{{ state.stateCode }}">{{
                                state.stateDescription }}</mat-option>
                        </mat-select>
                        <mat-error class="form-error" *ngIf="stateFormControl.hasError('required')"
                            i18n="@@payment-automatic-form.form.error.required">payment-automatic-form.form.error.required</mat-error>
                    </mat-form-field>
                    <span fxFlex="20%" fxHide.lt-md></span>
                </div>
                <!-- <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
          <mat-form-field fxFlex="15%" fxFlex.lt-md="100%">
            <input
              matInput
              i18n-placeholder="@@payment-automatic-form.form.zip-code.label"
              placeholder="payment-automatic-form.form.zip-code.label"
              type="text"
              [formControl]="zipCodeFormControl"
              autocomplete="off"
              [minLength]="fieldValidations.payment.zipCodeMinLength"
              [maxlength]="fieldValidations.payment.zipCodeMaxLength"
              onkeypress="return isNumberKey(this, event, 0)"
              required
            />
            <mat-error
              class="form-error"
              *ngIf="zipCodeFormControl.hasError('required')"
              i18n="@@payment-automatic-form.form.error.required"
              >payment-automatic-form.form.error.required</mat-error
            >
            <mat-error
              class="form-error"
              *ngIf="
                (zipCodeFormControl.hasError('minlength') || zipCodeFormControl.hasError('maxlength')) &&
                !zipCodeFormControl.hasError('required')
              "
              i18n="@@payment-automatic-form.form.zip-code.error"
              >payment-automatic-form.form.zip-code.error</mat-error
            >
          </mat-form-field>
          <span fxFlex="25%" fxHide.lt-md></span>
        </div>  -->
                <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
                    <mat-form-field fxFlex="20%" fxFlex.lt-md="100%"> <!-- *ngIf="allowPaymentInfoEdit" -->
                        <!-- 03/09/2021 RA - two input statements - one for zip code with only numbers, one that allows both numbers and letters -->
                        <input matInput i18n-placeholder="@@payment-automatic-form.form.zip-code.label"
                            placeholder="payment-automatic-form.form.zip-code.label" type="text"
                            [formControl]="zipCodeFormControl" autocomplete="postal-code"
                            [minLength]="getPaymentZipCodeMinLength(paymentAutomaticForm.get('countryFormControl').value)"
                            [maxlength]="getPaymentZipCodeMaxLength(paymentAutomaticForm.get('countryFormControl').value)"
                            *ngIf="!PaymentZipCodeOnlyAllowsNumbers()" />
                        <!-- required 03/29/2021 RA - Removed required as we are doing it programmatically -->
                        <input matInput i18n-placeholder="@@payment-automatic-form.form.zip-code.label"
                            placeholder="payment-automatic-form.form.zip-code.label" type="text"
                            [formControl]="zipCodeFormControl" autocomplete="postal-code"
                            [minLength]="getPaymentZipCodeMinLength(paymentAutomaticForm.get('countryFormControl').value)"
                            [maxlength]="getPaymentZipCodeMaxLength(paymentAutomaticForm.get('countryFormControl').value)"
                            onkeypress="return isNumberKey(this, event, 0)" *ngIf="PaymentZipCodeOnlyAllowsNumbers()" />
                        <!--required 03/29/2021 RA - Removed required as we are doing it programmatically -->
                        <mat-error class="form-error" *ngIf="zipCodeFormControl.hasError('required')"
                            i18n="@@payment-automatic-form.form.error.required">payment-automatic-form.form.error.required</mat-error>
                        <!-- 03/10/2021 RA - Added country to error check as to not show multiple error statements -->
                        <mat-error *ngIf="((zipCodeFormControl.hasError('minlength') || zipCodeFormControl.hasError('maxlength') ||
                       zipCodeFormControl.hasError('pattern') || zipCodeFormControl.hasError('required')) &&
                      paymentAutomaticForm.get('countryFormControl').value === 'USA')"
                            i18n="@@payment-automatic-form.form.zip-code.error-USA">payment-automatic-form.form.error.zip-code</mat-error>
                        <!-- 03/10/2021 RA - Added Canadian error message for invalid Zip Code pattern and check country -->
                        <mat-error *ngIf="((zipCodeFormControl.hasError('minlength') || zipCodeFormControl.hasError('maxlength') ||
                       zipCodeFormControl.hasError('pattern') || zipCodeFormControl.hasError('required')) &&
                       paymentAutomaticForm.get('countryFormControl').value === 'CAN')"
                            i18n="@@payment-automatic-form.form.zip-code.error-CAN">payment-automatic-form.form.error.zip-code</mat-error>
                        <!-- 03/25/2021 RA - Added Foreign error message for invalid Zip Code pattern and check country -->
                        <mat-error
                            *ngIf="((zipCodeFormControl.hasError('minlength') || zipCodeFormControl.hasError('maxlength') ||
                     zipCodeFormControl.hasError('pattern')) && paymentAutomaticForm.get('countryFormControl').value === 'FOR')"
                            i18n="@@payment-automatic-form.form.zip-code.error-FOR">payment-automatic-form.form.error.zip-code</mat-error>
                    </mat-form-field>
                    <mat-form-field fxFlex="20%" fxFlex.lt-md="100%" *ngIf="allowPaymentInfoEdit">
                        <input matInput i18n-placeholder="@@payment-automatic-form.form.zip-code.label"
                            placeholder="payment-automatic-form.form.zip-code.label" type="text"
                            [value]="noteAutoPayInformation.zipCode" autocomplete="off" />
                    </mat-form-field>
                    <span fxFlex="20%" fxHide.lt-md></span>
                </div>
                <br>
                <div fxLayout="column">
                    <div
                        *ngIf="isBrowserIE && media.isActive('lt-md'); else paymentAutomaticFormScheduleFlexColumnTemplate">
                        <ng-container *ngTemplateOutlet="paymentAutomaticFormScheduleFlexColumnTemplate"></ng-container>
                    </div>
                </div>

                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap.lt-md="10px" fxLayoutAlign="center center"
                    class="display-text normal-paragraph-spacing"
                    *ngIf="autoPaymentSelected.autoPaymentActionType === autoPaymentActionType.Setup">
                    <!-- PAYMENT SELECTION SECTION -->
                    <div class="payment-methods-section">

                        <mat-radio-group class="form-radio-group" [formControl]="paymentTypeFormControl">
                            <!-- Credit Card Option -->
                            <mat-radio-button class="form-radio-button" [value]="paymentType.CreditCard"
                                *ngIf="noteAutoPayInformation.acceptCreditCardFlag"
                                i18n-matTooltip="@@quick-pay-payment-form.form.payment-type.visa.tool-tip"
                                matTooltip="quick-pay-payment-form.form.payment-type.visa.tool-tip">
                                <div class="image-container">
                                    <img src="../assets/visa_dark.png" alt="Visa" />
                                    <img src="../assets/mastercard_dark.png" alt="MasterCard" />
                                    <img src="../assets/amex_dark.png" alt="American Express" />
                                    <img src="../assets/discover_dark.png" alt="Discover" />
                                </div>
                            </mat-radio-button>

                            <!-- eCheck Option -->
                            <mat-radio-button class="form-radio-button" [value]="paymentType.ElectronicCheck"
                                *ngIf="noteAutoPayInformation.acceptCreditCardFlag"
                                matTooltip="Pay with Electronic Check">
                                <img src="../assets/echeck.png" alt="eCheck" class="echeck-image" />
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>

                <!-- Need to show Braintree loading of dropdowns and ready state -->
                <div fxLayout="row" fxLayoutAlign="center center" class="display-text"
                    *ngIf="isPaymentTypeCreditCard() && autoPaymentSelected.autoPaymentActionType === autoPaymentActionType.Setup">
                    <mat-spinner color="accent" diameter="32" *ngIf="showBraintreeSpinner"></mat-spinner>
                </div>

                <!-- Credit Card Form -->
                <div fxLayout="row" fxLayoutAlign="center center" class="display-text field-container"
                    *ngIf="isPaymentTypeCreditCard() && autoPaymentSelected.autoPaymentActionType === autoPaymentActionType.Setup">
                    <div fxFlex="25%" fxFlex.lt-md="100%" class="textfield--float-label">
                        <label class="hosted-field--label" for="credit-card-number">Credit Card
                            Number<sup>*</sup></label>
                        <div id="credit-card-number" class="hosted-field"></div>
                        <div id="credit-card-number-error" class="error-message"></div>
                    </div>
                </div>

                <div fxLayout="row" fxLayoutAlign="center center" class="display-text"
                    *ngIf="isPaymentTypeCreditCard() && autoPaymentSelected.autoPaymentActionType === autoPaymentActionType.Setup">
                    <div fxFlex="10%" fxFlex.lt-md="50%" class="textfield-exp--label">
                        <label class="hosted-exp-field--label" for="expiration-month">Exp Month<sup>*</sup></label>
                        <div id="expiration-month" class="hosted-field"></div>
                    </div>
                    <div fxFlex="15%" fxFlex.lt-md="50%" class="textfield-exp-year-label textfield-exp--label">
                        <label class="hosted-exp-field--label" for="expiration-year">Exp Year<sup>*</sup></label>
                        <div id="expiration-year" class="hosted-field"></div>
                    </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center" class="display-text field-container"
                    *ngIf="isPaymentTypeCreditCard() && autoPaymentSelected.autoPaymentActionType === autoPaymentActionType.Setup">
                    <div fxFlex="25%" fxFlex.lt-md="100%" class="textfield--float-label">
                        <div id="expiration-date-error" class="error-exp-date-message"></div>
                    </div>
                </div>

                <div fxLayout="row" fxLayoutAlign="center center" class="display-text required-bottom-margin"
                    *ngIf="isPaymentTypeCreditCard() && autoPaymentSelected.autoPaymentActionType === autoPaymentActionType.Setup">
                    <div fxFlex="10%" fxFlex.lt-md="100%" class="textfield--float-label">
                        <label class="hosted-field--label" for="cvv">CVV<sup>*</sup></label>
                        <div id="cvv" class="hosted-field"></div>
                        <div id="cvv-error" class="error-message"></div>
                    </div>
                    <div fxFlex="15%" fxFlex.lt-md="100%"></div>
                </div>

                <!-- ACH Form -->
                <div fxLayout="row" fxLayoutAlign="center center" class="display-text normal-paragraph-spacing"
                    *ngIf="!isPaymentTypeCreditCard() && autoPaymentSelected.autoPaymentActionType === autoPaymentActionType.Setup">
                    <mat-radio-group fxFlex="100%" fxLayout.lt-md="column" fxLayoutAlign="center center"
                        class="form-radio-group display-text" [formControl]="bankAccountTypeFormControl">
                        <mat-radio-button class="form-radio-button" [value]="bankAccountType.Checking"><span
                                i18n="@@payment-automatic-form.form.bank-account-type.checking.label">payment-automatic-form.form.bank-account-type.checking.label</span></mat-radio-button>
                        <mat-radio-button class="form-radio-button" [value]="bankAccountType.Savings"><span
                                i18n="@@payment-automatic-form.form.bank-account-type.savings.label">payment-automatic-form.form.bank-account-type.savings.label</span></mat-radio-button>
                    </mat-radio-group>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center" class="display-text"
                    *ngIf="!isPaymentTypeCreditCard() && autoPaymentSelected.autoPaymentActionType === autoPaymentActionType.Setup">
                    <mat-form-field fxFlex="25%" fxFlex.lt-md="100%">
                        <input matInput i18n-placeholder="@@payment-automatic-form.form.bank-routing-number.label"
                            placeholder="payment-automatic-form.form.bank-routing-number.label" type="text"
                            [formControl]="bankRoutingNumberFormControl" autocomplete="off"
                            [minLength]="fieldValidations.payment.bank.bankRoutingNumberMinLength"
                            [maxlength]="fieldValidations.payment.bank.bankRoutingNumberMaxLength"
                            onkeypress="return isNumberKey(this, event, 0)" required onCopy="return false"
                            onDrag="return false" onDrop="return false" onPaste="return false" />
                        <mat-error class="form-error" *ngIf="bankRoutingNumberFormControl.hasError('required')"
                            i18n="@@payment-automatic-form.form.error.required">payment-automatic-form.form.error.required</mat-error>
                        <mat-error class="form-error" *ngIf="
                (bankRoutingNumberFormControl.hasError('minlength') || bankRoutingNumberFormControl.hasError('maxlength')) &&
                !bankRoutingNumberFormControl.hasError('required')
              " i18n="@@payment-automatic-form.form.bank-routing-number.error">payment-automatic-form.form.bank-routing-number.error</mat-error>
                    </mat-form-field>
                </div>

                <div fxLayout="row" fxLayoutAlign="center center" class="display-text"
                    *ngIf="!isPaymentTypeCreditCard() && autoPaymentSelected.autoPaymentActionType === autoPaymentActionType.Setup">
                    <mat-form-field fxFlex="25%" fxFlex.lt-md="100%">
                        <input matInput i18n-placeholder="@@payment-automatic-form.form.bank-account-number.label"
                            placeholder="payment-automatic-form.form.bank-account-number.label" type="text"
                            [formControl]="bankAccountNumberFormControl" autocomplete="off"
                            [minLength]="fieldValidations.payment.bank.bankAccountNumberMinLength"
                            [maxlength]="fieldValidations.payment.bank.bankAccountNumberMaxLength"
                            onkeypress="return isNumberKey(this, event, 0)" required onCopy="return false"
                            onDrag="return false" onDrop="return false" onPaste="return false" />
                        <mat-error class="form-error" *ngIf="bankAccountNumberFormControl.hasError('required')"
                            i18n="@@payment-automatic-form.form.error.required">payment-automatic-form.form.error.required</mat-error>
                        <mat-error class="form-error" *ngIf="
                (bankAccountNumberFormControl.hasError('minlength') || bankAccountNumberFormControl.hasError('maxlength')) &&
                !bankAccountNumberFormControl.hasError('required')
              " i18n="@@payment-automatic-form.form.bank-account-number.error">payment-automatic-form.form.bank-account-number.error</mat-error>
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center" class="display-text"
                    *ngIf="!isPaymentTypeCreditCard() && autoPaymentSelected.autoPaymentActionType === autoPaymentActionType.Setup">
                    <mat-form-field fxFlex="25%" fxFlex.lt-md="100%">
                        <input matInput
                            i18n-placeholder="@@payment-automatic-form.form.bank-account-number-confirm.label"
                            placeholder="payment-automatic-form.form.bank-account-number-confirm.label" type="text"
                            [formControl]="bankAccountNumberConfirmFormControl" autocomplete="off"
                            [minLength]="fieldValidations.payment.bank.bankAccountNumberMinLength"
                            [maxlength]="fieldValidations.payment.bank.bankAccountNumberMaxLength"
                            onkeypress="return isNumberKey(this, event, 0)" required onCopy="return false"
                            onDrag="return false" onDrop="return false" onPaste="return false" />
                        <mat-error class="form-error" *ngIf="bankAccountNumberConfirmFormControl.hasError('required')"
                            i18n="@@payment-automatic-form.form.error.required">payment-automatic-form.form.error.required</mat-error>
                        <mat-error class="form-error" *ngIf="
                (bankAccountNumberConfirmFormControl.hasError('minlength') || bankAccountNumberConfirmFormControl.hasError('maxlength')) &&
                !bankAccountNumberConfirmFormControl.hasError('required')
              " i18n="@@payment-automatic-form.form.bank-account-number-confirm.error">payment-automatic-form.form.bank-account-number-confirm.error</mat-error>
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center"
                    class="display-text form-error-display-text normal-paragraph-spacing"
                    *ngIf="!isPaymentTypeCreditCard() && autoPaymentSelected.autoPaymentActionType === autoPaymentActionType.Setup">
                    <span fxFlex="25%" fxFlex.lt-md="100%" fxLayoutAlign="left start">
                        <mat-error class="form-error"
                            *ngIf="bankAccountNumberEqualsFormControl.invalid && !bankAccountNumberConfirmFormControl.hasError('required')"
                            i18n="@@payment-automatic-form.form.bank-account-number-confirm-equals.error">payment-automatic-form.form.bank-account-number-confirm-equals.error</mat-error>
                        <!-- the following is used as a spacer so the screen does not shift-->
                        <mat-error class="form-error"
                            *ngIf="!(bankAccountNumberEqualsFormControl.invalid && !bankAccountNumberConfirmFormControl.hasError('required'))">&nbsp;</mat-error>
                    </span>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center"
                    class="display-text normal-paragraph-pre-spacing normal-paragraph-spacing"
                    *ngIf="!isPaymentTypeCreditCard() && autoPaymentSelected.autoPaymentActionType === autoPaymentActionType.Setup">
                    <img src="../assets/ach_example_check.jpg" style="max-width: 100%; height: auto;"
                        alt="ACH Example Check" />
                </div>
                <div fxLayout="row" fxLayoutAlign="center center" class="display-text normal-paragraph-spacing"
                    *ngIf="!isPaymentTypeCreditCard() && autoPaymentSelected.autoPaymentActionType === autoPaymentActionType.Setup">
                    <span
                        i18n="@@payment-automatic-form.form.bank-account-info.not-found-statement">payment-automatic-form.form.bank-account-info.not-found-statement</span>
                </div>
            </div>
        </form>
    </div>
</ng-template>

<ng-template #paymentAutomaticFormScheduleFlexColumnTemplate>
    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="center center" class="display-text">
        <div fxFlex="20%" fxHide.lt-md></div>
        <div fxFlex="60%" fxFlex.lt-md="100%" fxLayoutAlign="center center" class="border-bottom-blue"
            style="margin-top: 16px; margin-bottom: 16px;"></div>
        <div fxFlex="20%" fxHide.lt-md></div>
    </div>

    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="center center"
        class="display-text normal-paragraph-spacing">
        <div fxFlex="20%" fxHide.lt-md></div>
        <div fxFlex="60%" fxFlex.lt-md="100%" fxLayoutAlign="center center">
            <b><span
                    i18n="@@payment-automatic-form.form.schedule.title">payment-automatic-form.form.schedule.title</span>&nbsp;{{
                noteId }}</b>
        </div>
        <div fxFlex="20%" fxHide.lt-md></div>
    </div>
    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="center center" class="display-text"
        *ngIf="noteAutoPayInformation.scheduleOneNumberPayments !== null && noteAutoPayInformation.scheduleOneNumberPayments > 0">
        <div fxFlex="20%" fxHide.lt-md></div>
        <mat-form-field fxFlex="20%" fxFlex.lt-md="100%" ngStyle.gt-sm="padding-left: 10px; padding-right: 10px">
            <input matInput i18n-placeholder="@@payment-automatic-form.form.schedule.start-date.label"
                placeholder="payment-automatic-form.form.schedule.start-date.label" type="text"
                [value]="noteAutoPayInformation.scheduleOneStartDate | date: 'MM/dd/yyyy'" autocomplete="off" readonly />
        </mat-form-field>
        <mat-form-field fxFlex="20%" fxFlex.lt-md="100%" ngStyle.gt-sm="padding-left: 10px; padding-right: 10px">
            <input matInput i18n-placeholder="@@payment-automatic-form.form.schedule.number-payments.label"
                placeholder="payment-automatic-form.form.schedule.number-payments.label" type="text"
                [value]="noteAutoPayInformation.scheduleOneNumberPayments" autocomplete="off" readonly />
        </mat-form-field>
        <mat-form-field fxFlex="20%" fxFlex.lt-md="100%" ngStyle.gt-sm="padding-left: 10px; padding-right: 10px">
            <input matInput i18n-placeholder="@@payment-automatic-form.form.schedule.payment-amount.label"
                placeholder="payment-automatic-form.form.schedule.payment-amount.label" type="text"
                [value]="noteAutoPayInformation.scheduleOnePaymentAmount | currency" autocomplete="off" readonly />
        </mat-form-field>
        <div fxFlex="20%" fxHide.lt-md></div>
    </div>
    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="center center" class="display-text"
        *ngIf="noteAutoPayInformation.scheduleTwoNumberPayments !== null && noteAutoPayInformation.scheduleTwoNumberPayments > 0">
        <div fxFlex="20%" fxHide.lt-md></div>
        <mat-form-field fxFlex="20%" fxFlex.lt-md="100%" ngStyle.gt-sm="padding-left: 10px; padding-right: 10px">
            <input matInput i18n-placeholder="@@payment-automatic-form.form.schedule.start-date.label"
                placeholder="payment-automatic-form.form.schedule.start-date.label" type="text"
                [value]="noteAutoPayInformation.scheduleTwoStartDate | date: 'MM/dd/yyyy'" autocomplete="off" readonly
                 />
        </mat-form-field>
        <mat-form-field fxFlex="20%" fxFlex.lt-md="100%" ngStyle.gt-sm="padding-left: 10px; padding-right: 10px">
            <input matInput i18n-placeholder="@@payment-automatic-form.form.schedule.number-payments.label"
                placeholder="payment-automatic-form.form.schedule.number-payments.label" type="text"
                [value]="noteAutoPayInformation.scheduleTwoNumberPayments" autocomplete="off" readonly />
        </mat-form-field>
        <mat-form-field fxFlex="20%" fxFlex.lt-md="100%" ngStyle.gt-sm="padding-left: 10px; padding-right: 10px">
            <input matInput i18n-placeholder="@@payment-automatic-form.form.schedule.payment-amount.label"
                placeholder="payment-automatic-form.form.schedule.payment-amount.label" type="text"
                [value]="noteAutoPayInformation.scheduleTwoPaymentAmount | currency" autocomplete="off" readonly
                />
        </mat-form-field>
        <div fxFlex="20%" fxHide.lt-md></div>
    </div>
    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="center center" class="display-text"
        *ngIf="noteAutoPayInformation.scheduleThreeNumberPayments !== null && noteAutoPayInformation.scheduleThreeNumberPayments > 0">
        <div fxFlex="20%" fxHide.lt-md></div>
        <mat-form-field fxFlex="20%" fxFlex.lt-md="100%" ngStyle.gt-sm="padding-left: 10px; padding-right: 10px">
            <input matInput i18n-placeholder="@@payment-automatic-form.form.schedule.start-date.label"
                placeholder="payment-automatic-form.form.schedule.start-date.label" type="text"
                [value]="noteAutoPayInformation.scheduleThreeStartDate | date: 'MM/dd/yyyy'" autocomplete="off" readonly
                 />
        </mat-form-field>
        <mat-form-field fxFlex="20%" fxFlex.lt-md="100%" ngStyle.gt-sm="padding-left: 10px; padding-right: 10px">
            <input matInput i18n-placeholder="@@payment-automatic-form.form.schedule.number-payments.label"
                placeholder="payment-automatic-form.form.schedule.number-payments.label" type="text"
                [value]="noteAutoPayInformation.scheduleThreeNumberPayments" autocomplete="off" readonly />
        </mat-form-field>
        <mat-form-field fxFlex="20%" fxFlex.lt-md="100%" ngStyle.gt-sm="padding-left: 10px; padding-right: 10px">
            <input matInput i18n-placeholder="@@payment-automatic-form.form.schedule.payment-amount.label"
                placeholder="payment-automatic-form.form.schedule.payment-amount.label" type="text"
                [value]="noteAutoPayInformation.scheduleThreePaymentAmount | currency" autocomplete="off" readonly
                 />
        </mat-form-field>
        <div fxFlex="20%" fxHide.lt-md></div>
    </div>
    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="center center" class="display-text"
        *ngIf="noteAutoPayInformation.scheduleFourNumberPayments !== null && noteAutoPayInformation.scheduleFourNumberPayments > 0">
        <div fxFlex="20%" fxHide.lt-md></div>
        <mat-form-field fxFlex="20%" fxFlex.lt-md="100%" ngStyle.gt-sm="padding-left: 10px; padding-right: 10px">
            <input matInput i18n-placeholder="@@payment-automatic-form.form.schedule.start-date.label"
                placeholder="payment-automatic-form.form.schedule.start-date.label" type="text"
                [value]="noteAutoPayInformation.scheduleFourStartDate | date: 'MM/dd/yyyy'" autocomplete="off" readonly
                 />
        </mat-form-field>
        <mat-form-field fxFlex="20%" fxFlex.lt-md="100%" ngStyle.gt-sm="padding-left: 10px; padding-right: 10px">
            <input matInput i18n-placeholder="@@payment-automatic-form.form.schedule.number-payments.label"
                placeholder="payment-automatic-form.form.schedule.number-payments.label" type="text"
                [value]="noteAutoPayInformation.scheduleFourNumberPayments" autocomplete="off" readonly />
        </mat-form-field>
        <mat-form-field fxFlex="20%" fxFlex.lt-md="100%" ngStyle.gt-sm="padding-left: 10px; padding-right: 10px">
            <input matInput i18n-placeholder="@@payment-automatic-form.form.schedule.payment-amount.label"
                placeholder="payment-automatic-form.form.schedule.payment-amount.label" type="text"
                [value]="noteAutoPayInformation.scheduleFourPaymentAmount | currency" autocomplete="off" readonly
                 />
        </mat-form-field>
        <div fxFlex="20%" fxHide.lt-md></div>
    </div>
    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="center center" class="display-text"
        *ngIf="noteAutoPayInformation.scheduleFiveNumberPayments !== null && noteAutoPayInformation.scheduleFiveNumberPayments > 0">
        <div fxFlex="20%" fxHide.lt-md></div>
        <mat-form-field fxFlex="20%" fxFlex.lt-md="100%" ngStyle.gt-sm="padding-left: 10px; padding-right: 10px">
            <input matInput i18n-placeholder="@@payment-automatic-form.form.schedule.start-date.label"
                placeholder="payment-automatic-form.form.schedule.start-date.label" type="text"
                [value]="noteAutoPayInformation.scheduleFiveStartDate | date: 'MM/dd/yyyy'" autocomplete="off" readonly
                disabled />
        </mat-form-field>
        <mat-form-field fxFlex="20%" fxFlex.lt-md="100%" ngStyle.gt-sm="padding-left: 10px; padding-right: 10px">
            <input matInput i18n-placeholder="@@payment-automatic-form.form.schedule.number-payments.label"
                placeholder="payment-automatic-form.form.schedule.number-payments.label" type="text"
                [value]="noteAutoPayInformation.scheduleFiveNumberPayments" autocomplete="off" readonly disabled />
        </mat-form-field>
        <mat-form-field fxFlex="20%" fxFlex.lt-md="100%" ngStyle.gt-sm="padding-left: 10px; padding-right: 10px">
            <input matInput i18n-placeholder="@@payment-automatic-form.form.schedule.payment-amount.label"
                placeholder="payment-automatic-form.form.schedule.payment-amount.label" type="text"
                [value]="noteAutoPayInformation.scheduleFivePaymentAmount | currency" autocomplete="off" readonly
                disabled />
        </mat-form-field>
        <div fxFlex="20%" fxHide.lt-md></div>
    </div>
    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="center center"
        class="display-text normal-paragraph-spacing">
        <div fxFlex="20%" fxHide.lt-md></div>
        <div fxFlex="60%" fxFlex.lt-md="100%" fxLayoutAlign="center center" class="border-bottom-blue"
            style="margin-top: 16px; margin-bottom: 16px;"></div>
        <div fxFlex="20%" fxHide.lt-md></div>
    </div>
</ng-template>
<!--10/07/20221 RA - Added new Legal Text -->
<ng-template #paymentAutomaticFormMainFlexColumnTemplate2>
    <div fxFlex="100%" class="display-text normal-paragraph-spacing" *ngIf="CompanyCode_Check()">
        <span i18n="@@payment-automatic-form.main.top-statement.1">payment-automatic-form.main.top-statement.1</span>
        <br />&nbsp;<br /><b><span style="text-decoration: underline;"
                i18n="@@payment-automatic-form.main.top-statement.2">payment-automatic-form.main.top-statement.2</span></b>
    </div>
    <div fxFlex="100%" class="display-text normal-paragraph-spacing" *ngIf="!CompanyCode_Check()">
        <span i18n="@@payment-automatic-form.main.top-statement.1a">payment-automatic-form.main.top-statement.1a</span>
        <br />&nbsp;<br /><b><span style="text-decoration: underline;"
                i18n="@@payment-automatic-form.main.top-statement.2">payment-automatic-form.main.top-statement.2</span></b>
    </div>
</ng-template>

<ng-template #paymentAutomaticFormOptionsFlexColumnTemplate>
    <!-- 10/06/2021 RA - Moved Statement to before button -->
    <div fxFlex="100%" class="display-text" fxLayoutAlign="center center">
        <button #SubmitButton mat-flat-button color="primary" (click)="setup()" [disabled]="isFormValid()"
            *ngIf="autoPaymentSelected.autoPaymentActionType === autoPaymentActionType.Setup"
            i18n="@@payment-automatic-form.form.setup-button.label">
            payment-automatic-form.form.setup-button.label
        </button>
        <button mat-stroked-button color="warn" (click)="cancel()"
            *ngIf="autoPaymentSelected.autoPaymentActionType === autoPaymentActionType.Cancel"
            i18n="@@payment-automatic-form.form.cancel-button.label">
            payment-automatic-form.form.cancel-button.label
        </button>
    </div>
</ng-template>

<ng-template #paymentAlternativePaymentsTemplate>
    <div fxLayout="row" fxLayoutAlign="center" class="display-text">
        <!-- ALTERNATE PAYMENT OPTIONS -->
        <div class="alt-payments-section">
            <div *ngIf="browserSupportsApplePay" id="apple-pay-button"
                class="apple-pay-button apple-pay-button-black pay-button" matTooltip="Pay with Apple Pay"></div>
            <div id="google-pay-button" class="googlePayContainer pay-button" matTooltip="Pay with Google Pay">
            </div>
            <!-- <div id="paypal-button" class="pay-button" matTooltip="Pay with PayPal"></div> -->
        </div>
    </div>
</ng-template>